export const scrollToFormField = (ref) => {
  ref?.current.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  });
};
